import React from "react";
import Slider from "react-slick";
import "./slider.css";
function MultipleRows({ images, type }) {
  console.log("images:", images);

  const settings = {
    dots: false, // No dots for a cleaner look
    infinite: true, // Infinite scrolling
    slidesToShow: window.window.innerWidth > 700 ? 5 : 2,
    slidesToScroll: 1,
    autoplay: true,
    speed: 4000, // Increase speed for smoother effect
    autoplaySpeed: 0, // Set to 0 for non-stop movement
    cssEase: "linear", // Ensures smooth scrolling
    pauseOnHover: false, // Prevents pausing on hover
    arrows: false, // Hides navigation arrows
    rtl :  type == 's' ? true : type == "b" ?    false :   true
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {Array.isArray(images) &&
          images.map((x, index) =>
            type !== "s" ? (
              <div key={index} className="cardcar">
                <img className="frdss" src={x} alt={`slide-${index}`} />
              </div>
            ) : (
              <div className="cardcarCircle">
                <img className="inggcircle" src={x} />
              </div>
            )
          )}
      </Slider>
    </div>
  );
}

export default MultipleRows;
